module.exports = __webpack_public_path__ + "media/images/flags/64/Democratic-Republic-of-the-Congo-66fd2be30c417e64ddcb23d22f39fe87.png";